import React from "react";
import MainContainer from "../../components/main-container/MainContainer";
import { useNavigate } from "react-router-dom";

function HomePage({setIsLoggedIn}) {
  const navigate=useNavigate();
  const handleLogOut = () => {
    navigate("/");
    setIsLoggedIn(false);
    sessionStorage.clear("accesstoken");
    sessionStorage.clear("userName");
  };
  return (
    <>
      <MainContainer
        showLogoutButton={true}
        handleLogOut={handleLogOut}
      >
       <div style={{textAlign:"center",marginTop:"15%"}}>
        <h1 style={{fontWeight:"bold", color:"grey"}}>{`Welcome ${sessionStorage.getItem("userName")}`}</h1>
       </div>
      </MainContainer>
    </>
  );
}

export default HomePage;
